import { DASHBOARD_TYPES } from "store/types";

const initialState = {
  dataCounts: null,
  series: [],
  pie: [],
  period: null,
  weeklyActivity: [],
  demographics: null,
  topCountries: [],
  newListings: [],
  storeAnalytics: null,
  wallet: null,
};

const dashboardReducers = (state = initialState, action) => {
  switch (action.type) {
    case DASHBOARD_TYPES.DATA_COUNTS:
      return {
        ...state,
        dataCounts: action.payload.counts,
        series: action.payload.bar,
        pie: action.payload.pie,
        period: action.payload.period,
        weeklyActivity: action.payload.weeklyActivity,
        demographics: action.payload.demographics,
        topCountries: action.payload.topCountries,
        newListings: action.payload.newListings,
        storeAnalytics: action.payload.storeAnalytics,
        wallet: action.payload.wallet,
      };
    case DASHBOARD_TYPES.DATA_BAR:
      return {
        ...state,
        series: action.payload,
      };
    default:
      return state;
  }
};

export default dashboardReducers;
